import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useCurrentEditor } from '@tiptap/react';
import { Tooltip } from 'antd';

import { getTooltipOverlayClass } from '../../../../../utils/helpers/themeHelpers';

import { nodeTypes } from '../../constants/nodeTypes';
import { headingOptions, headingOptionsValues } from '../../toolbar/constants';

import { selectDarkMode } from '../../../../../userBrowserSettings/store/browserSettings.selectors';

const classes = {
    tooltipOverlay: 'toolbar-tooltip-overlay heading-tooltip-overlay',
};

const supportedOutlineHeadingKeys = [
    headingOptionsValues.heading_2,
    headingOptionsValues.heading_3,
    headingOptionsValues.heading_4,
    headingOptionsValues.heading_5,
    headingOptionsValues.heading_6,
];

const useOutlineHeadingOptions = () => {
    const darkMode = useSelector(selectDarkMode);

    const { editor } = useCurrentEditor();

    const outlineHeadingOptions = headingOptions.filter((option) =>
        supportedOutlineHeadingKeys.includes(option.value)
    );

    const headingOptionsWithH1 = useMemo(() => {
        const h1Option = headingOptions.find(
            (option) => option.value === headingOptionsValues.heading_1
        );
        const disabled =
            editor.storage.h1Manage.hasH1 && !editor.isActive(nodeTypes.heading, { level: 1 });

        return [
            {
                ...h1Option,
                disabled: disabled,
                label: (
                    <Tooltip
                        overlayClassName={`${classes.tooltipOverlay} ${getTooltipOverlayClass(
                            darkMode
                        )}`}
                        placement='right'
                        title={disabled ? 'Only one H1 tag is allowed per outline' : ''}
                    >
                        {h1Option.label}
                    </Tooltip>
                ),
            },
            ...outlineHeadingOptions,
        ];
    }, [editor, outlineHeadingOptions, darkMode]);

    return headingOptionsWithH1;
};

export default useOutlineHeadingOptions;
